<template src="./index.html"></template>

<script>
import { URL, apiCall } from "@/utils/api";
import mixin from "@/mixins/index";
import ConditionalMedia from "@/components/partials/ConditionalMedia/index";

export default {
  name: "ProblemForm",
  mixins: [mixin],
  components: {
    "conditional-media": ConditionalMedia,
  },
  props: { selected: Object },
  data() {
    return {
      tmpDetail: {
        id: null,
        offices: [],
        officeIds: [],
        text: null,
        priorityId: null,
        files: [],
        fileList: [],
        address: null,
        executiveId: null,
        streetId: null,
        streetKey: null,
        opNote: null,
        initOfIds: [],
      },
      prevProblem: null,
      searchTimeout: null,
      strSearchTimeout: null,
      action: URL[process.env.NODE_ENV].service_api + "files",
      priorities: null,
      filterStreets: [],
      streetsAll: [],
      executives: [],
      offices: [],
      detailsErrror: null,
      fileList: [],
      streetSpin: false,
      addressSpin: false,
      mediadialogVisibility: false,
      errorOb: {
        filesError: null,
        priorityError: null,
        officeError: null,
        addressError: null,
        executiveError: null,
        streetError: null,
      },
    };
  },
  methods: {
    handleStreetChange(val) {
      this.$emit("searchSimilar", {
        executiveId: this.tmpDetail.executiveId,
        streetKey: val,
        address: this.tmpDetail.address,
      });
    },
    handlePhoneKeyDown(e) {
      if (isNaN(Number(e.key))) e.preventDefault();
    },
    handleExecutiveChange(val) {
      if (!val) return;
      let executive = this.executives.find((item) => item.id == val);
      if (executive) {
        this.tmpDetail.streetId = null;
        this.tmpDetail.streetKey = null;
        this.tmpDetail.executive = executive;
        this.$emit("searchSimilar", {
          executiveId: val,
          streetKey: this.tmpDetail.streetKey,
          address: this.tmpDetail.address,
        });
      }
    },
    handleUploadChange({ fileList }) {
      this.fileList = fileList;
    },
    addDetail() {
      if (!this.validateFields()) return;
      let offices = [];
      this.tmpDetail.officeIds.forEach((element) => {
        offices.push(
          this.offices.find((val) => {
            return val.id == element;
          })
        );
      });
      if (this.tmpDetail.id != null || this.tmpDetail.prevProblemId != null) {
        let priority = this.priorities.find((val) => {
          return val.id == this.tmpDetail.priorityId;
        });
        this.tmpDetail.priority = priority;
        this.tmpDetail.offices = offices;
        this.$emit("save", this.tmpDetail);
      } else {
        let street = this.streetsAll.find(
          (item) => item.id == this.tmpDetail.streetId
        );
        let priority = this.priorities.find((val) => {
          return val.id == this.tmpDetail.priorityId;
        });

        let newDetail = {
          offices: offices,
          text: this.tmpDetail.text,
          priority: priority,
          files: this.fileList.map((val) => {
            return { path: val.response.data };
          }),
          address: this.tmpDetail.address,
          executive: this.tmpDetail.executive,
          fileList: this.fileList,
          street: street,
          opNote: this.tmpDetail.opNote,
        };
        this.$emit("save", newDetail);
      }

      this.resetTmpDetail();
    },
    clearValidation() {
      this.errorOb = {
        filesError: null,
        priorityError: null,
        officeError: null,
        executiveError: null,
        streetError: null,
      };
    },
    cancelSelected() {
      this.$emit("cancelled");
      this.resetTmpDetail();
    },
    resetTmpDetail() {
      this.tmpDetail = {
        id: null,
        prevId: null,
        offices: [],
        officeIds: [],
        officeError: null,
        priorityError: null,
        filesError: null,
        text: null,
        priorityId: null,
        priority: null,
        files: [],
        address: null,
        streetId: null,
        opNote: null,
        executiveId: null,
        executive: null,
        locationStr: null,
        initOfIds: [],
      };
      this.fileList = [];
      this.detailsErrror = null;
      this.prevProblem = null;
      this.clearValidation();
    },
    searchStreets(value) {
      let smallValue = value.toLowerCase();
      clearTimeout(this.strSearchTimeout);
      this.strSearchTimeout = setTimeout(() => {
        this.streetSpin = true;
        this.getStreets(null, value, this.tmpDetail.executiveId);
      }, 2000);
    },
    setPrevProblem(problem) {
      this.prevProblem = problem;
      this.tmpDetail.prevProblemId = problem.id;
      this.tmpDetail.executiveId = problem.executive.id;
      this.tmpDetail.address = problem.address;
    },
    getOffices() {
      apiCall({
        url: URL[process.env.NODE_ENV].auth_api + "structures/offices",
        method: "GET",
        params: {
          parent: true,
        },
      })
        .then((response) => {
          if (!response.data.error) this.offices = response.data.data.entities;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleAddressChange(e) {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.addressSpin = true;
        this.$emit("searchSimilar", {
          executiveId: this.tmpDetail.executiveId,
          streetKey: this.tmpDetail.streetKey,
          address: e.target.value,
        });
      }, 3000);
    },

    isDisabled(o) {
      return this.tmpDetail.initOfIds.indexOf(o) > -1;
    },
    validateFields() {
      let result = true;
      if (!this.tmpDetail.executiveId) {
        this.$set(
          this.errorOb,
          "executiveError",
          "Qurum mütləq seçilməlidir."
        );
        result = false;
      } else {
        this.$set(this.errorOb, "executiveError", null);
      }
      if (this.tmpDetail.streetKey) {
        this.tmpDetail.streetId = isNaN(
          parseInt(this.tmpDetail.streetKey.substr(6))
        )
          ? null
          : parseInt(this.tmpDetail.streetKey.substr(6));
      }
      if (!this.tmpDetail.streetId) {
        this.$set(this.errorOb, "streetError", "Zəhmət olmasa küçəni seçin!");
        result = false;
      } else {
        this.$set(this.errorOb, "streetError", null);
      }
      if (!this.tmpDetail.address) {
        this.$set(
          this.errorOb,
          "addressError",
          "Zəhmət olmasa ünvanı təsvir edin!"
        );
        result = false;
      } else {
        this.$set(this.errorOb, "addressError", null);
      }
      /* if(!this.tmpDetail.officeIds || this.tmpDetail.officeIds.length==0){
                this.$set(this.errorOb,'officeError',"Zəhmət olmasa orqanları seçin!");
                result=false;
            }else {this.$set(this.errorOb,'officeError',null);} */
      if (!this.tmpDetail.priorityId) {
        this.$set(
          this.errorOb,
          "priorityError",
          "Zəhmət olmasa əhəmiyyət dərəcəsi seçin!"
        );
        result = false;
      } else {
        this.$set(this.errorOb, "priorityError", null);
      }
      if (!this.tmpDetail.text && this.fileList.length == 0) {
        this.$set(
          this.errorOb,
          "detailsError",
          "Şikayətin mətni və ya faylları daxil edilməlidir!"
        );
        result = false;
      } else {
        this.$set(this.errorOb, "detailsError", null);
      }
      return result;
    },
  },
  watch: {
    selected: function () {
      if (this.selected) {
        Object.assign(this.tmpDetail, this.selected);
        if (this.selected.id) {
          this.tmpDetail.text = null;
          this.$set(this.tmpDetail, "exist", true);
        }
        this.tmpDetail.priorityId = this.tmpDetail.priority.id;
        this.$set(this.tmpDetail, "address", this.tmpDetail.address);

        if (this.tmpDetail.officeDetails) {
          this.$set(
            this.tmpDetail,
            "officeIds",
            this.tmpDetail.officeDetails.map((item) => item.parentOffice.id)
          );
          this.tmpDetail.initOfIds = this.tmpDetail.officeIds;
        }
        this.tmpDetail.streetId = this.tmpDetail.street.id;
        this.tmpDetail.streetKey = "street" + this.tmpDetail.streetId;
        this.filterStreets = [this.tmpDetail.street];
        this.tmpDetail.executiveId = this.selected.executive.id;
        this.fileList = this.tmpDetail.fileList;
      } else {
        this.resetTmpDetail();
      }
    },
  },
  created() {
    this.getExecutives();
    this.getOffices();
    // this.getStreets();
  },
};
</script>
<style lang="scss" scoped src="./index.scss"></style>
